import { render, staticRenderFns } from "./attachments-list.vue?vue&type=template&id=d342246c&"
import script from "./attachments-list.vue?vue&type=script&lang=ts&"
export * from "./attachments-list.vue?vue&type=script&lang=ts&"
import style0 from "./attachments-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports